import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogPrimaryShortcut,
} from './ui/dialog';
import { Button } from './ui/button';
import { CancelButton } from './ui/cancel-button';

interface StyleCalibrationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  pendingSuggestionsCount?: number;
}

export const StyleCalibrationModal: React.FC<StyleCalibrationModalProps> = ({
  isOpen,
  onClose,
  onAccept,
  pendingSuggestionsCount = 0,
}) => {
  const { t } = useLocale();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="mb-4">{t('style_calibration_needed_title') || 'Calibraci?n de estilo necesaria'}</DialogTitle>
          <DialogDescription>
            {t('style_calibration_needed_message') || 'Se necesita una calibraci?n de estilo antes de revisar un texto largo. Se activar? un an?lisis en un fragmento m?s corto. Luego, acepta y rechaza sugerencias, el estilo se calibrar? autom?ticamente y se podr?n solicitar an?lisis largos.'}
          </DialogDescription>
          {pendingSuggestionsCount > 5 && (
            <DialogDescription className="mt-2">
              {t('style_calibration_existing_suggestions') || 'Ya hay algunas sugerencias. Presiona cancelar y ac?ptalas o rech?zalas para que la calibraci?n se active autom?ticamente.'}
            </DialogDescription>
          )}
        </DialogHeader>
        <DialogFooter>
          <CancelButton onClick={onClose} />
          <Button dialogPrimary onClick={onAccept} className="inline-flex items-center gap-1.5">
            {t('accept') || 'Aceptar'}
            <DialogPrimaryShortcut className="ml-0.5" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
